import React from 'react';
import { CyclePrediction } from '../../types';

interface PeriodReminderCardProps {
  prediction: CyclePrediction | null;
}

const PeriodReminderCard: React.FC<PeriodReminderCardProps> = ({ prediction }) => {
  if (!prediction) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const nextStart = new Date(prediction.nextPeriodStart);
  nextStart.setHours(0, 0, 0, 0);
  const daysUntil = Math.ceil((nextStart.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  if (daysUntil > 3 || daysUntil < 0) return null;

  const formatDate = (date: Date): string =>
    date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  return (
    <div className="bg-gradient-to-r from-red-50 to-pink-50">
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-2xl" role="img" aria-label="reminder">🔔</span>
          <h3 className="text-lg font-bold text-gray-900">Period Reminder</h3>
        </div>

        {/* Countdown */}
        <div className="text-center mb-4">
          <p className="text-5xl font-bold text-red-500">{daysUntil}</p>
          <p className="text-sm text-gray-600 mt-1">days until your next period</p>
        </div>

        {/* Prediction Details */}
        <div className="space-y-2 text-sm text-gray-700">
          <div className="flex items-center justify-between bg-white/60 rounded-xl px-3 py-2">
            <span className="flex items-center gap-1">
              <span className="text-green-500">●</span> Fertile Window
            </span>
            <span className="font-medium">
              {formatDate(prediction.fertileWindowStart)} – {formatDate(prediction.fertileWindowEnd)}
            </span>
          </div>
          <div className="flex items-center justify-between bg-white/60 rounded-xl px-3 py-2">
            <span className="flex items-center gap-1">
              <span className="text-pink-500">●</span> Ovulation
            </span>
            <span className="font-medium">{formatDate(prediction.ovulationDate)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeriodReminderCard;
